<template>
  <v-container>
    <v-card
      :loading="false"
    >
      <v-overlay
        :absolute="true"
        :value="isComponentLoading"
      >
        <v-progress-circular indeterminate size="24"></v-progress-circular>
      </v-overlay>
      <v-row class="pa-3">
        <v-col cols="12">
          <v-text-field
            v-model="searchText"
            :hint="lang($store, 'sap/listings.global.filter.hints.search_name')"
            persistent-hint
            single-line
            :loading="false"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            v-model="searchParams.active"
            :hint="lang($store, 'sap/listings.global.filter.hints.status')"
            :items="statusItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            v-model="searchParams.role"
            :hint="lang($store, 'sap/listings.global.filter.hints.role')"
            :items="rolesItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
/* constants */
import statusFilter from '@/mixins/filters/statusFilter';
import searchTextFilter from '@/mixins/filters/searchTextFilter';
import {
  MANAGER_TOP, MANAGER_BASE, MANAGER_COMPLEX, MANAGER_SERVICE,
} from '../../constants/roles';
/* mixins */
import isComponentLoading from '../../mixins/isComponentLoading';

export default {
  name: 'FilterManagers',
  mixins: [
    isComponentLoading,
    statusFilter,
    searchTextFilter,
  ],
  props: {
    defaultSearchParams: {
      type: Object,
      default: () => ({
        search: '',
        active: 1,
        role: null,
      }),
    },
  },
  data() {
    return {
      searchParams: {},
    };
  },
  mounted() {
    this.searchParams = {
      search_contact: this.defaultSearchParams.search,
      active: this.defaultSearchParams.active,
      role: this.defaultSearchParams.role,
    };
  },
  computed: {
    rolesItems() {
      return [
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.roles.all'),
          value: null,
        },
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.roles.manager_top'),
          value: MANAGER_TOP,
        },
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.roles.manager_base'),
          value: MANAGER_BASE,
        },
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.roles.manager_complex'),
          value: MANAGER_COMPLEX,
        },
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.roles.manager_service'),
          value: MANAGER_SERVICE,
        },
      ];
    },
    account() {
      return this.$store.getters['account/account'];
    },
  },
  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('filtering', newVal);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>

</style>
